import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {ItemKey} from "../item/core/ItemKey";
import {Schema} from "@/common/Schema";
import { _ } from "core-js";

export const POSITIVE_FILTERS = {
    MAJOR: 1,
    MINOR: 2
};

export const NEGATIVE_FILTERS = {
    SKIP_LOCKED: 1,
    SKIP_UNLOCKED: 2
};

export class SearchConfig extends Cloneable {



    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(SearchConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(SearchConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._minor = false;
        this._major = false
        this._skipLocked = false;
        this._skipUnlocked = false;
        this._sources = [];

        this._positiveFilters = [];
        this._negativeFilters = [];

        this._useFilters = false;
    }

    get minor() {
        return this._minor;
    }

    set minor(value) {
        this._minor = value;
    }

    get major() {
        return this._major;
    }

    set major(value) {
        this._major = value;
    }

    get skipLocked() {
        return this._skipLocked;
    }

    set skipLocked(value) {
        this._skipLocked = value;
    }

    get sources() {
        return this._sources;
    }

    set sources(value) {
        this._sources = value;
    }

    get skipUnlocked() {
        return this._skipUnlocked;
    }

    set skipUnlocked(value) {
        this._skipUnlocked = value;
    }

    get positiveFilters() {
        return this._positiveFilters;
    }
    
    set positiveFilters(value) {
        this._positiveFilters = value;
    }

    get negativeFilters() {
        return this._negativeFilters;
    }

    set negativeFilters(value) {
        this._negativeFilters = value;
    }

    get useFilters() {
        return this._useFilters;
    }
    
    set useFilters(value) {
        this._useFilters = value;
    }

    valid() {

        if (this.sources && this.sources.some(v => !v || !v.valid() || v.any())) {
            return false;
        }

        if(this.skipLocked && this.skipUnlocked) {
            return false;
        }

        if(this.negativeFilters && 
           this.negativeFilters.includes(NEGATIVE_FILTERS.SKIP_LOCKED) && 
           this.negativeFilters.includes(NEGATIVE_FILTERS.SKIP_UNLOCKED)) {
            return false;
        }

        return true;
    }

    empty() {
        return !(this.minor || this.major || this.sources.length > 0 || this.positiveFilters.length > 0 || this.negativeFilters.length > 0 || this.skipLocked || this.skipUnlocked);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SearchConfig());
        } else if (target instanceof SearchConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SearchConfig, {
    _minor: alias("minor", Schema.primitive()),
    _major: alias("major", Schema.primitive()),

    _skipLocked: alias("skip_locked", Schema.primitive()),
    _skipUnlocked: alias("skip_unlocked", Schema.primitive()),

    _useFilters: alias("use_filters", Schema.primitive()),

    _positiveFilters: alias("positive_filters", list(Schema.primitive())),
    _negativeFilters: alias("negative_filters", list(Schema.primitive())),

    _sources: alias("sources", list(ItemKey.schema()))
});